import { ACCOUNTANT_ACCESS_SETTING, Role } from 'consts/common.const';
import { appRoutes } from 'routes';
import { RouteMiddleware, useRouterMemo } from 'services/route';
import { userPermission } from './user-permission';

const roleAccessSetting = [Role.ACCOUNTANT, Role.ROOT];

function normalizePath(path: string): string {
  let newPath = path;

  if (path && path.lastIndexOf('/') === path.length - 1) {
    newPath = path.substr(0, path.length - 1);

    if (newPath.lastIndexOf('/') === newPath.length - 1) {
      newPath = normalizePath(newPath);
    }
  }

  return newPath;
}

export class UserPermissionGuard implements RouteMiddleware {
  async process(): Promise<boolean | string> {
    const path = useRouterMemo.pathname || '';

    let currentPath = normalizePath(path);
    let mapPath = '';

    let mapPage = await userPermission.getMapPage();

    mapPage = [...mapPage, '/doc/view'];

    const pathToArr = currentPath.split('/').filter((v) => v === '0' || !!v);

    const userRightKeys = userPermission.getUserRightKeys();

    // apply for all role
    if (
      `${location.host}/setting/`.includes(currentPath.split('/')[1]) &&
      !roleAccessSetting.includes(userPermission.getUserProfile().role)
    ) {
      return '/forbidden';
    }

    // apply for accountant role

    if (
      !ACCOUNTANT_ACCESS_SETTING.includes(currentPath) &&
      `${location.host}/setting/`.includes(currentPath.split('/')[1]) &&
      userPermission.getUserProfile().role === Role.ACCOUNTANT
    ) {
      return '/forbidden';
    }

    if (!userRightKeys.includes(pathToArr[0]))
      // Accept if exclude role declare / Or 404
      return true;

    if (pathToArr.length === 1) {
      mapPath = `/${pathToArr[0]}/view`;
    }

    //array: [{fullPath: url}]
    const flattenIds = (arr) =>
      arr && arr.flatMap(({ fullPath, children }) => [].concat({ fullPath }, flattenIds(children)));

    //flatten array : ['url','url2'...]
    const listRoter = flattenIds(appRoutes).reduce((courst: any[], item) => {
      if (item?.fullPath) {
        return courst.concat(item?.fullPath);
      }

      return courst;
    }, []);

    const ckeckUrl = listRoter.filter((item) => item.includes(pathToArr[0]));

    let x = '';

    //get the url part that is not a variable (vd: cv/1/2 => cv)
    pathToArr.forEach((item) => {
      ckeckUrl.forEach((itemData) => {
        if (
          !itemData
            .split('/')
            .filter((v) => !!v)
            .includes(item)
        )
          return;

        if (x.includes(item)) return;

        return (x = `${x}/${item}`);
      });
    });

    if (pathToArr.length >= 2) {
      mapPath = x;
    }

    // check url exists in appRoutes
    let checkUrls = ckeckUrl
      .filter((item) => item.includes(x))
      .some((item) => {
        if (item.slice(x.length).indexOf(':') === -1) return item === currentPath;

        return (
          +item
            .slice(x.length)
            .split(':')
            .filter((v) => v !== '/').length ===
          +currentPath
            .slice(x.length)
            .split('')
            .filter((y) => y === '/').length
        );
      });

    //['edit,'add',...]
    const permissionName = new Set(mapPage.map((item) => item.slice(item.lastIndexOf('/'))));
    //check url can grant permission
    const checkSurvival = mapPath.split('/').some((item) => permissionName.has(`/${item}`));

    // Forbidden
    if (!mapPage.includes(mapPath) ? (!checkSurvival ? !checkUrls : true) : false) return '/forbidden';

    return true;
  }
}
